import { useLocation, useNavigate } from "react-router-dom";
import InfoRole from "./InfoRole";
import { useEffect } from "react";

const InfoLocal = (props) => {
    const navegar = useNavigate()
    const rotaAtiva = useLocation()
    const parametros = new URLSearchParams(rotaAtiva.search)
    const idRole = JSON.parse(parametros.get('idRole'))
    const local = props.locais.find(elemento => elemento.id == parametros.get('id'))
    const eventosLocal = props.eventos.filter(elemento => elemento.cep == local.cep && elemento.numero == local.numero)
    const divRolagem = document.getElementById('conteudo')

    useEffect(()=>{
        if(divRolagem){divRolagem.scrollTo({ top: 0, behavior: 'smooth' })}
    }, [])

    return(
        <div className="flex flex-coll min-h-screen">
            <div className="fixed top-0 left-1/2 -translate-x-1/2 flex w-screen max-w-2xl items-center bg-purple-950 text-white h-16 px-5 shadow-md z-20">
                <div
                    className="flex items-center gap-2 cursor-pointer hover:scale-105 transition-transform duration-300"
                    onClick={() => navegar(parametros.get('voltar') ?? '/')}
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    <p className="text-sm">Voltar</p>
                </div>
                <div className="flex-1 flex justify-center overflow-hidden">
                    <div className="text-lg font-bold truncate max-w-[70%] text-center">{local.nome}</div>
                </div>
            </div>

            <div className="flex flex-col items-center pt-20">
                <div className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-2xl mb-6 space-y-6">
                    <div className="flex justify-between items-center text-purple-800 font-semibold text-lg">
                        <div>{local.categoria}</div>
                        <div className="flex items-center gap-1">
                            <span>{local.estrelas}</span>
                            <svg className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
                                <path d="M10 15l-5.878 3.09 1.122-6.545L.487 6.91l6.562-.955L10 0l2.951 5.955 6.562.955-4.757 4.635 1.122 6.545z" />
                            </svg>
                        </div>
                    </div>
                    <div className="flex items-center gap-2 text-gray-700 text-sm">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a2 2 0 011.98 1.7l.27 2a2 2 0 01-.45 1.64l-1.27 1.53a11.05 11.05 0 005.45 5.45l1.53-1.27a2 2 0 011.64-.45l2 .27A2 2 0 0121 17.72V21a2 2 0 01-2 2h-1C7.82 23 1 16.18 1 8V7a2 2 0 012-2z" />
                        </svg>
                        <span>{local.telefone}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-700 text-sm">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3a9 9 0 100 18 9 9 0 000-18z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.05 12h19.9" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2.05c3.94 3.45 3.94 16.5 0 19.9" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2.05c-3.94 3.45-3.94 16.5 0 19.9" />
                        </svg>
                        <a href={local.site.startsWith('http') ? local.site : `https://${local.site}`} target="_blank" rel="noopener noreferrer" className="hover:underline">
                            {local.site}
                        </a>
                    </div>
                    <div className="flex items-start gap-2 text-gray-700 text-sm">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 21s-6-5.686-6-10a6 6 0 1112 0c0 4.314-6 10-6 10z" />
                        </svg>
                        <div>
                            {`${local.logradouro}, ${local.numero}, ${local.bairro}, ${local.cidade} - ${local.estado}, ${local.cep}`}
                        </div>
                    </div>
                    <div className="flex justify-between items-center text-sm mt-3">
                        <span className="text-gray-600">Distância: {eventosLocal[0].distancia} km</span>
                        <a href={local.linkGoogleMaps} target="_blank" className="bg-purple-700 text-white px-4 py-2 rounded-full text-xs hover:bg-purple-800 transition-colors">
                            Ver no Google Maps
                        </a>
                    </div>
                    {local.funcionamento && (
                        <div className="flex items-center gap-2 text-sm text-gray-600 mt-2">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-7a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>{local.funcionamento}</span>
                        </div>
                    )}
                </div>
                <InfoRole idRole={idRole} eventosLocal={eventosLocal} />
            </div>
        </div>
    )
}

export default InfoLocal;
